<div class="container_dialog">
    <div class="header_popup header_popup_center">
      <div class="title_popup title_popup_center">
          <span>{{"companies.documents_Files"|translate}}</span>
      </div>
      <button (click)="closed()">
          <mat-icon style="color: black;">close</mat-icon>
      </button>
  </div>
    <div >
      <div class="content">
        <table class="listing_table">
            <tbody>
              <ng-container *ngFor="let file of selectedFiles; let selectedFileIndex = index">
                <tr class="body_table_catalog">
                  <td class="td_block file_block">
                    <img src="../../../../../assets/icones/doc.svg" alt="">
                    <span class="bold_span">{{ file.filename }}</span>
                  </td>
                  <td>
                    <button (click)="removeFile(selectedFileIndex, 'selectedFiles')">
                      <mat-icon style="color: #ADB5BD;">delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>          
      </div>
    </div>
    <button style="width: 30px; display: flex; justify-content: start; align-items: center; flex-direction: column; color: #6449DB;" class="add_btn" type="button" (click)="fileInput.click()">
        <img src="assets/icones/add_icon.svg" alt="add_file">
        <span>{{ "common.add" | translate }}</span>
        <input 
          #fileInput
          type="file"
          (change)="onFileChange($event)" 
          multiple 
          style="display: none;" 
        />
      </button> 
    <div class="submet_btns">
   
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()" >
        <span>{{"common.back"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn " (click)="save()">
          <span> {{"common.save"|translate | uppercase}}</span>
          <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
  </div>
  </div>
  